import { gql } from '@apollo/client';
import { useCallback } from 'react';
import { subscriptionsPublicClient } from 'lib/apollo/clients';
import {
  CANADIAN_COUNTRY_CODE,
  US_COUNTRY_CODE,
} from 'components/BusinessDetails';

export const COUNTRY_BY_IP_QUERY = gql`
  query {
    countryByIp {
      country
    }
  }
`;

export const useCountryByIpQuery = () =>
  useCallback(async () => {
    try {
      const {
        data: {
          countryByIp: { country },
        },
      } = await subscriptionsPublicClient.query({
        query: COUNTRY_BY_IP_QUERY,
      });

      return {
        clientCountry: country,
        validCountry: [US_COUNTRY_CODE, CANADIAN_COUNTRY_CODE].includes(
          country
        ),
      };
    } catch (e) {
      window.newrelic?.noticeError?.(new Error(e));
    }
  }, []);
